// extracted by mini-css-extract-plugin
export default {"tupacGrid":"in-z","tupacHeader":"jn-z","tupacHeader2":"kn-z","tupacMenu":"ln-z","tupacMenu2":"mn-z","tupacMain":"nn-z","tupacMain2":"on-z"};